import { FaberApi, JetpacCatalogApi, NewJetpacSimApi } from "api"

class CatalogAPI {
  /**
   * to list all available plans within the shop / catalog
   */
  static getCatalogPlans() {
    return FaberApi.httpGet('/catalog/esim/plans')
  }

  /**
   * to list all faber travel products
   */

  static getAllFaberCatalogPlans(
    faberToken: string,
    limit: number,
    offset: number,
    filterParams: FilterParamsProps
  ) {
    let queryParams = ''

    // if filter params are added
    if (Object.keys(filterParams).length > 0) {
      // add to queryparams
      for (const filterKey in filterParams) {
        queryParams += `&${filterKey}=${filterParams[filterKey]}`
      }
    }

    // if no filter or sort params, just fetch up to limit and as per offset
    return FaberApi.httpGet(
      `/catalog/item/detail?limit=${limit}&offset=${offset}${queryParams}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    ).then((res) => res.data)
  }

  static async createTelnaPackage(body: PackageModel) {
    return JetpacCatalogApi.httpPost(
      `/catalog/ops/vendor/telna/package`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static async getAllCatalogItems(faberToken: string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/item`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data.body.data)
  }

  static async searchCatalogItems(faberToken: string, term: string) {
    return FaberApi.httpGet(
      `/sim/ops/catalog/search?catalogName=${encodeURIComponent(term)}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async getTrafficPolicies(faberToken: string) {
  const res = await FaberApi.httpGet(
    `/sim/ops/telna/traffic-policies`,
    { Authorization: `Bearer ${faberToken}` },
    true
  )

  return res.data.data
}


  static async getAllTelnaPackages(faberToken: string) {
    return JetpacCatalogApi.httpGet(
      `/catalog/ops/vendor/telna/package`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async createCatalogItem(body: CreateCatalogPayload) {
    const { faberToken, ...payload } = body
    return FaberApi.httpPost(
      `/sim/ops/catalog`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      payload
    )
  }

  static async updateCatalogPrice(body: CatalogPriceModel) {
    return FaberApi.httpPost(
      `/sim/ops/price`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }
  static async getAllProvisionMethods(faberToken: string) {
    return JetpacCatalogApi.httpGet(
      `/catalog/ops/provisionmethods`,
      { 
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getAllCatalogPages(page: number, limit: number) {
    return FaberApi.httpGet(
      `/sim/revamp/destinations?page=${page}&limit=${limit}`,
      {},
      true,
      {},
      false
    ).then((res) => res.data)
  }
  static async createCatalogPage(body: CatalogPage[]) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/pages/item`,
      {
        Authorization: `Bearer ${body[0].faberToken}`
      },
      body
    )
  }
  static async archiveCatalogFormPage(faberToken: string, body: ArchiveCatalogPayload) {
    return FaberApi.axios({
      method: 'delete',
      url: `/sim/ops/catalog/archive`,
      headers: {
        Authorization: `Bearer ${faberToken}`
      },
      data: body,
      withCredentials: true
    }).then((res) => res)
  }
  static async getAllCatalogItemsById(faberToken: string, id:string) {
    return FaberApi.httpGet(
      `/orbit/catalog/ops/pages/${id}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getCatalogInfoByPageId(faberToken: string, pageId: string) {
    return FaberApi.httpGet(
      `/sim/ops/catalog/pages/${pageId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async getNonMappedCatalogItems(faberToken: string) {
    return FaberApi.httpGet(
      `/sim/ops/catalog/non-mapped`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async mapCatalogToDestination(
    faberToken: string,
    body: MapCatalogPayload
  ) {
    return FaberApi.httpPost(
      `/sim/ops/catalog/map`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    ).then((res) => res.data)
  }
  static async getCatalogDetails(faberToken: string, catalogId: string) {
    return FaberApi.httpGet(
      `/sim/ops/catalog/details/${catalogId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static async updateCatalogDetails(
    faberToken: string,
    catalogId: string,
    body: Record<string, unknown>
  ) {
    return FaberApi.httpPatch(
      `/sim/ops/catalog/${catalogId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    ).then((res) => res.data)
  }
  static async AddFkCatalog(body: PageFkCatalog[]) {
    return FaberApi.httpPost(
      `/orbit/catalog/ops/pages/fk_catalog`,
      {
        Authorization: `Bearer ${body[0].faberToken}`
      },
      body
    )
  }

  static async flushCacheByPrefix(faberToken: string, prefix: string) {
    return NewJetpacSimApi.httpPost(
      `/sim/revamp/cache/flush?prefix=${encodeURIComponent(prefix)}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    ).then((res) => res.data)
  }
}
export default CatalogAPI
export interface FilterParamsProps {
  orderBy?: string
  isBonus?: boolean
  isRollover?: boolean
  isTopup?: boolean
  isBase?: boolean
  showClient?: boolean
}

export interface PackageModel {
  name: string
  trafficPolicyId: number
  supportedCountries: string[]
  preferredImsiId: number
  voiceUsageAllowanceInSeconds: number
  dataUsageAllowanceInBytes: number
  smsUsageAllowanceInNums: number
  timeAllowanceInSeconds: number
  activationTimeAllowanceInSeconds: number
  activationType: string
  dateEarliestActivation: number
  dateEarliestAvailable: number
  dateLatestAvailable: number
  notes: string
  dataUsageAllowanceType: string
  voiceUsageAllowanceType: string
  smsUsageAllowanceType: string
  faberToken: string
}

export interface CreateCatalogPayload {
  tenant: string
  vendor: string
  packageType: string
  packageTypeId: string | number
  name: string
  description: string[]
  callout?: string
  dataInGB: string | number
  voiceInMins: string | number
  sms: string | number
  validityInDays: string | number
  countries: string[]
  visibility: boolean
  supports5g: boolean
  redirectUrl?: string
  tags: string[]
  provisionMethodFk: string | number
  vendorPackageId: string
  faberToken: string
}

export interface CatalogPriceModel {
  catalog_id: string
  currency: string
  unit_amount: number
  faberToken: string
}

export interface CatalogPage {
  name: string
  displayName:string
  destinationType:string
  faberToken: string 
}
export interface PageFkCatalog {
  catalogPageID: string
  catalogID: string
  faberToken:string
}

export interface ArchiveCatalogPayload {
  destinationName: string
  catalogId: string
  page_id: string
}

export interface MapCatalogPayload {
  destinationName: string
  catalogId: string
  pageId: string
  visibility: boolean
}
